export default __webpack_public_path__ + "static/media/ansible_project2.dc9d464d.PNG";